import React from "react";
import { Typo } from "@ers/ui/";

export const TITLE = "Nowy regulamin";
export const Content = () => (
    <>
        <Typo.Body className="with-margin--bottom-2">
            {"W dniu "}
            <Typo.Body.Bold style={{ display: "inline" }}>
                {"20.03.2026"}
            </Typo.Body.Bold>
            {" roku w życie wchodzi nowy Regulamin Konta Kandydata."}
        </Typo.Body>
        <Typo.Body className="with-margin--bottom-2">
            {"Pełną treść nowego regulaminu znajdziesz pod linkiem "}
            <Typo.Link
                target="_blank"
                rel="noopener noreferrer"
                url="https://erecruiter.pl/_files/konto_kandydata/Regulamin_swiadczenia_uslugi_Konto_Kandydata_2026-03-16.pdf"
            >
                Regulamin_swiadczenia_uslugi_Konto_Kandydata_2026-03-16.pdf
            </Typo.Link>
            .
        </Typo.Body>
        <Typo.Body className="with-margin--bottom-2">
            {"W razie pytań napisz do nas na adres "}
            <Typo.Link
                target="_blank"
                rel="noopener noreferrer"
                url="mailto:konto@erecruiter.pl"
            >
                konto@erecruiter.pl
            </Typo.Link>
            .
        </Typo.Body>
        <Typo.Body>
            Jeśli nie akceptujesz zmian w regulaminie, możesz odstąpić od umowy
            rezygnując z konta.
        </Typo.Body>
    </>
);
